import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body no-padding" }
const _hoisted_8 = { class: "settings-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "settings-list-item-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-corner no-transition", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Select a currency")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCurrencies, (c) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "settings-list-item",
              key: c.id,
              tabindex: "0",
              onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
              onClick: ($event: any) => (_ctx.changeCurrency(c.id))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["settings-list-item-icon", { 'check-invisible': c.id !== _ctx.currency }])
              }, _hoisted_11, 2),
              _createElementVNode("div", _hoisted_12, _toDisplayString(c.name), 1)
            ], 40, _hoisted_9))
          }), 128))
        ])
      ])
    ])
  ], 42, _hoisted_1))
}